export default "__VITE_ASSET__DQSu80y7__"